"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultCalculationPropsF = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

var _DataSection = _interopRequireDefault(require("./sections/DataSection"));

var _ResultSection = _interopRequireDefault(require("./sections/ResultSection"));

var _calculateKpp = _interopRequireDefault(require("./formulas/calculateKpp"));

var _calculateFivePercentsAdd = _interopRequireDefault(require("./formulas/calculateFivePercentsAdd"));

var _calculateAdditionalContribution = _interopRequireDefault(require("./formulas/calculateAdditionalContribution"));

var _Button = _interopRequireDefault(require("./components/Button"));

var _calculateEconomy = _interopRequireDefault(require("./formulas/calculateEconomy"));

var _LandingSection = require("./sections/LandingSection");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  color: ", ";\n  /* border: ", "; */\n\n\n  @media (max-width: ", ") {\n\n  }\n\n  @media (max-width: ", "){\n    display:block;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GlobalStyles = (0, _styledComponents.createGlobalStyle)(_templateObject(), _Button.default);

var AppStyled = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.backgroundMain;
}, function (props) {
  return props.theme.colorMain;
}, function () {
  return process.env.NODE_ENV === "development" ? "1px solid black" : "none";
}, function (props) {
  return props.theme.breakpointXL;
}, function (props) {
  return props.theme.breakpointLG;
});

var defaultCalculationPropsF = function defaultCalculationPropsF(isLanding) {
  return {
    fot: 1500000000,
    employees: 800,
    avgPayment: isLanding ? 1500000000 / 800 : 1350,
    contribution: isLanding ? 20 : 5,
    penetration: 25
  };
};

exports.defaultCalculationPropsF = defaultCalculationPropsF;
var defaultCalcResult = {
  kpp: 0,
  economy: 0,
  indexation: {
    fivePercentAdd: 0,
    additionalContribution: 0
  },
  motivation: {
    kppContribution: 0,
    targetContribution: 0
  }
};

var App = function App(props) {
  var isLanding = props.isLanding,
      antikrizis = props.antikrizis,
      _props$fot = props.fot,
      fot = _props$fot === void 0 ? 1500000000 : _props$fot,
      _props$employees = props.employees,
      employees = _props$employees === void 0 ? 800 : _props$employees,
      _props$avgPayment = props.avgPayment,
      avgPayment = _props$avgPayment === void 0 ? isLanding ? fot / 800 : 1350 : _props$avgPayment,
      _props$contribution = props.contribution,
      contribution = _props$contribution === void 0 ? isLanding ? 20 : 5 : _props$contribution,
      _props$penetration = props.penetration,
      penetration = _props$penetration === void 0 ? 25 : _props$penetration;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      firstUpdate = _useState2[0],
      setFirstUpdate = _useState2[1];

  var _useState3 = (0, _react.useState)({
    fot: fot,
    employees: employees,
    avgPayment: avgPayment,
    contribution: contribution,
    penetration: penetration
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      calculationProps = _useState4[0],
      setCalculationProps = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultCalcResult),
      _useState6 = _slicedToArray(_useState5, 2),
      results = _useState6[0],
      setResults = _useState6[1];

  var calculate = function calculate(e) {
    if (e) {
      e.preventDefault();
    }

    var contribution = calculationProps.contribution,
        fot = calculationProps.fot,
        penetration = calculationProps.penetration;
    var avgPayment = calculationProps.avgPayment,
        employees = calculationProps.employees;

    if (isLanding) {
      avgPayment = fot / employees;
      employees = Math.round(employees * (penetration / 100));
    } //Десятичная дробь процента


    var contributionDecimal = contribution / 100;
    var newResults = {
      kpp: (0, _calculateKpp.default)(employees, avgPayment, contributionDecimal, antikrizis),
      economy: (0, _calculateEconomy.default)(employees, fot, contributionDecimal, avgPayment, antikrizis),
      //разность следующих доп расходов при индексации ЗП и бюджета КПП
      indexation: {
        fivePercentAdd: (0, _calculateFivePercentsAdd.default)(fot, contributionDecimal, antikrizis),
        // Рост объема ФОТ = (ФОТ+Индексация в %)-ФОТ без индексации
        additionalContribution: (0, _calculateAdditionalContribution.default)(employees, fot, contributionDecimal, avgPayment) // Доп. Страх. Взносы = Сумма налогов на ФОТ с учетом индексации – Сумма налогов на ФОТ без индексации

      },
      motivation: {
        kppContribution: (0, _calculateFivePercentsAdd.default)(fot, contributionDecimal, antikrizis, penetration),
        // Рост объема ФОТ = (ФОТ+Индексация в %)-ФОТ без индексации
        targetContribution: (0, _calculateFivePercentsAdd.default)(fot, contributionDecimal, antikrizis, penetration) * (2 / 100) //Целевой взнос НПФ = Стартовый взнос в КПП х 2%

      }
    };
    setResults(newResults);
  };

  (0, _react.useEffect)(function () {
    if (props.getValues) {
      var _antikrizis = {
        calculationData: calculationProps,
        calculatedValues: results
      };
      props.getValues(_antikrizis);
    }
  }, [results, calculationProps]);
  (0, _react.useEffect)(function () {
    calculate();
  }, [calculationProps]);
  (0, _react.useEffect)(function () {
    if (!isLanding) calculate();

    if (firstUpdate) {
      calculate();
      setFirstUpdate(false);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(GlobalStyles, null), /*#__PURE__*/_react.default.createElement(AppStyled, null, /*#__PURE__*/_react.default.createElement(_DataSection.default, {
    setCalculationProps: setCalculationProps,
    calculationProps: calculationProps,
    calculate: calculate,
    isPaymentDisabled: props.isPaymentDisabled,
    isLanding: isLanding,
    antikrizis: props.antikrizis
  }), isLanding ? /*#__PURE__*/_react.default.createElement(_LandingSection.LandingSection, {
    results: results,
    calculate: calculate,
    anchor: props.anchor,
    calculationProps: calculationProps
  }) : /*#__PURE__*/_react.default.createElement(_ResultSection.default, _extends({}, results, {
    calculate: calculate,
    anchor: props.anchor,
    calculationProps: calculationProps,
    getValues: props.getValues,
    results: results,
    customResultButton: props.customResultButton,
    showKppBudget: props.showKppBudget,
    showButton: props.showButton
  }))));
};

App.propTypes = {
  anchor: _propTypes.default.string.isRequired,
  isPaymentDisabled: _propTypes.default.bool.isRequired,
  getValues: _propTypes.default.func,
  isLanding: _propTypes.default.bool.isRequired,
  antikrizis: _propTypes.default.bool.isRequired,
  showKppBudget: _propTypes.default.bool,
  showButton: _propTypes.default.bool
};
var _default = App;
exports.default = _default;